import { render, staticRenderFns } from "./ReporteAreaSalle.vue?vue&type=template&id=754d7e48&scoped=true"
import script from "./ReporteAreaSalle.vue?vue&type=script&lang=js"
export * from "./ReporteAreaSalle.vue?vue&type=script&lang=js"
import style0 from "./ReporteAreaSalle.vue?vue&type=style&index=0&id=754d7e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754d7e48",
  null
  
)

export default component.exports